export default __webpack_public_path__ + "static/media/pic42.cf0ab094.jpg";